import {
  EmploymentStatus,
  FilingType,
  MaritalStatus,
  OnboardingRequirement,
  ProfileInput,
} from 'generated/types'
import type { Flow } from 'utils/FlowProvider/types'

export const removeUnnecessaryRequirements = (input: {
  allOnboardingRequirements: OnboardingRequirement[]
  suitability?: Partial<Record<keyof ProfileInput, unknown>> | null
  flow: Flow
}): OnboardingRequirement[] => {
  if (
    input.suitability === null ||
    input.suitability === undefined ||
    input.flow === 'investOnboarding'
  ) {
    return input.allOnboardingRequirements
  }

  // Some suitability questions are only shown if the customer selected
  // a specific answer to a previous question; route away from page
  // to not show it if that's the case
  let newRequirements = input.allOnboardingRequirements
  const maritalStatus = input.suitability.maritalStatus
  const filingType = input.suitability.filingType
  const employmentStatus = input.suitability.employmentStatus
  const selfEmployedIncome = input.suitability.selfEmployedIncome

  if (
    maritalStatus === MaritalStatus.widowed ||
    maritalStatus === MaritalStatus.single ||
    maritalStatus === MaritalStatus.divorced
  ) {
    newRequirements = newRequirements.filter(
      (requirement) =>
        requirement !== OnboardingRequirement.FILING_TYPE &&
        requirement !== OnboardingRequirement.COMBINED_ANNUAL_INCOME,
    )
  }
  if (filingType === FilingType.separateWholeYear) {
    // assuming marital status = married due to if statement above
    newRequirements = newRequirements.filter(
      (requirement) => requirement !== OnboardingRequirement.COMBINED_ANNUAL_INCOME,
    )
  } else if (filingType) {
    newRequirements = newRequirements.filter(
      (requirement) => requirement !== OnboardingRequirement.ANNUAL_INCOME,
    )
  }
  if (!!employmentStatus && employmentStatus !== EmploymentStatus.selfEmployed) {
    newRequirements = newRequirements.filter(
      (requirement) =>
        requirement !== OnboardingRequirement.SELF_EMPLOYED_INCOME &&
        requirement !== OnboardingRequirement.EMPLOYEES,
    )
  }
  if (selfEmployedIncome < 28_000) {
    // assuming employment status = self-employed due to if statement above
    newRequirements = newRequirements.filter(
      (requirement) => requirement !== OnboardingRequirement.EMPLOYEES,
    )
  }

  return newRequirements
}
